export default __webpack_public_path__ + "static/social-header-7cd0ef7d2cff7d652fca9282b152bbc4.jpeg";